import React from 'react'
import { useTranslation } from 'react-i18next'

import classnames from 'classnames'
import ExpenseReviewIcon from 'docReviewDashboard/common/ExpenseReviewStatusIcon'

import { PriorExpense } from 'core/application/docReviewDashboard/expenses/priorExpenses'

import CustomCollapse from 'common/components/dataDisplay/CustomCollapse'
import Icon from 'common/components/general/Icon'

import { parseZoneFormat } from 'common/dateFormatters'

import { ROUTE_PATHS } from '../../../../common/routePaths'
import DocumentComponent from '../../../common/DocumentComponet'

import './styles.less'

interface PriorExpenseItemProps extends PriorExpense {
  onPriorExpenseClick?: (id: string) => void
}

const PriorExpenseItem: React.FC<PriorExpenseItemProps> = (props) => {
  const { t: translate } = useTranslation()

  const flagIcon =
    props.isDuplicate &&
    props.matchCount > 0 &&
    Array.from({ length: props.matchCount }).map((_, index) => (
      <Icon key={index} type="far fa-flag" fontAwesome className="color-red-6" style={{ marginRight: '2px' }} />
    ))
  const activeQueueItem = classnames({ prior_expense_item__active: props.isDuplicate })

  const documentsContent = <DocumentComponent documents={props.attachments} />

  return (
    <div
      className={`${activeQueueItem} prior_expense__item cursor_pointer`}
      onClick={() => {
        if (props.onPriorExpenseClick) {
          props.onPriorExpenseClick(props.expenseId)
        } else {
          window.open(`${ROUTE_PATHS.DOC_REVIEW_EXPENSES}/${props.expenseId}`, '_blank').focus()
        }
      }}
    >
      <div className="flex__space_between">
        <p>
          {flagIcon} {props.serviceProvider}
        </p>
        <p>${props.approvedAmount}</p>
      </div>

      <div>
        <h6>{props.expenseType.name}</h6>
      </div>

      <div>
        <h6>#{props.expenseNumber}</h6>
      </div>

      <div className="flex__space_between flex__space_between_centered">
        <span className="color-gray-7">Date of service: {parseZoneFormat(props.approvedPurchasedDate)}</span>
        {!props.isDuplicate && (
          <div>
            <ExpenseReviewIcon status={props.status} />
          </div>
        )}
      </div>
      {props.isDuplicate && (
        <div className="flex__space_between">
          <CustomCollapse
            title=""
            seeMoreTitle={translate('doc-review-dashboard.prior-expenses.see-more-documents')}
            seeLessTitle={translate('doc-review-dashboard.prior-expenses.see-less-documents')}
            itemsToShow={0}
            items={[]}
            contentOnly
            content={documentsContent}
          />
          <div>
            <ExpenseReviewIcon status={props.status} />
          </div>
        </div>
      )}
    </div>
  )
}

export default PriorExpenseItem
